var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Gallery',{staticClass:"residential-floorplan",attrs:{"value":_vm.items,"scroll-anchor":"floorplan","size":"contain"}})
}
var staticRenderFns = []

export { render, staticRenderFns }